(function() {
  'use strict';

  angular.module('app').controller('MessagesController', MessagesController);

  MessagesController.$inject = [
    '$scope',
    '$rootScope',
    '$filter',
    '$timeout',
    '$routeParams',
    'BusinessService',
    'MessageService',
    'SelectService',
    'NotifyService',
    '$uibModal',
    'blockUI',
    'SettingsService',
    '$sce'];

  function MessagesController(
      $scope, $rootScope, $filter, $timeout, $routeParams, BusinessService, MessageService, SelectService, NotifyService, $uibModal,
      blockUI,
      SettingsService, $sce) {

    $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
    $scope.getPages = getTotalPaginatedPages;
    $scope.getMessages = getMessages;
    $scope.user_id = false;
    if ($routeParams.user_id) {
      $scope.user_id = $routeParams.user_id;
    }
    $scope.params = {
      messages_preset: {
        page: 1,
        count: 20,
        date_from: moment().subtract(3, 'month').utc().toDate(),
        date_to: moment().endOf('day').utc().toDate(),
        time_from: moment().startOf('day').utc().toDate(),
        time_to: moment().endOf('day').utc().toDate(),
        sort_direction: 'DESC',
        sort_field: 'created',
        phone: null,
        message_type: 'all',
        src_type: 'all',
        status: 'all'
      }
    };

    $scope.data = {
      showTableDisplaySettings: false,
      summaryMessages: {},
      pagerLengths: [10, 20, 50, 100, 200],
      message_types: [
        {id: 'all', title: 'All'},
        {id: 'sms', title: 'SMS'},
        {id: 'push', title: 'Push'},
        {id: 'viber', title: 'Viber'},
        {id: 'email', title: 'E-mail'},
        {id: 'incust-messenger', title: '{{platform_name}} messenger'}
      ],
      src_types: [
        {id: 'all', title: 'All'},
        {id: 'system', title: 'System'},
        {id: 'business', title: 'Business'},
        {id: 'user', title: 'Customer'}
      ],
      statuses: [
        {id: 'all', title: 'All'},
        {id: 'wait', title: 'Wait'},
        {id: 'sent', title: 'Sent'},
        {id: 'delivered', title: 'Delivered'},
        {id: 'error', title: 'Error'}
      ]
    };

    $scope.data.table_cols_preset = [
      {
        visible: true,
        data: [
          {value: 'message', text: 'Message', visible: true}
        ]
      },
      {
        visible: true,
        data: [
          {value: 'title', text: 'Type', visible: true},
          {value: 'src_type', text: 'Sender', visible: true},
          {value: 'dst_type', text: 'Recipient', visible: true}
        ]
      },
      {
        visible: true,
        data: [
          {value: 'user_phone', text: 'Customer phone', visible: true},
          {value: 'user_name', text: 'Customer name', visible: true}
        ]
      },
      {
        visible: true,
        data: [
          {value: 'created', text: 'Created', visible: true},
          {value: 'status', text: 'Status', visible: true},
          {value: 'sended', text: 'Sent', visible: true},
          {value: 'delivered', text: 'Delivered', visible: true}
        ]
      },
      {
        visible: true,
        data: [
          {value: 'billing_amount', text: 'Cost', visible: true}
        ]
      },
      {
        visible: true,
        data: [
          {value: 'type', text: 'Delivery type', visible: true}
        ]
      }
    ];
    $scope.isSupportUserExternalId = false;
    var block_messages_list = blockUI.instances.get('messages_list');

    SettingsService.GetPlatformParams(function(success, response) {

      if (success) {
        $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;
        if ($scope.isSupportUserExternalId) {

          $scope.data.table_cols_preset[2].data.splice(0, 0, {
            value: 'user_external_id',
            text: 'Customer external id',
            visible: true,
            not_sortable: true
          });

          $scope.data.table_cols_preset.splice(3, 0, {
            visible: true,
            data: [
              {value: 'dst_external_id', text: 'Recipient external id', visible: true},
              {value: 'dst_phone', text: 'Recipient phone number', visible: true},
              {value: 'dst_email', text: 'Recipient email', visible: true}
            ]
          });
        }
      }

      initController();
    });

    function initMessageFilters() {
      $scope.params.messages = angular.copy($scope.params.messages_preset);
      SettingsService.GetPlatformParams(function(success, response) {
        if (success) {
          if (!!response.allow_messages_to_external_system) {
            $scope.data.message_types.push({
              id: 'external-system',
              title: 'TEXT_EXTERNAL_SYSTEM'
            });

          }
          if (!!response.pkpass_wallet_send_message) {
            $scope.data.message_types.push({
              id: 'pkpass-message',
              title: 'TEXT_PKPASS_MESSAGE'
            });
          }
        }
      });
    }

    function initTableColumns() {
      try {
        $scope.data.table_cols = JSON.parse($rootScope.ENV.filters.messages_list.table_cols);
      } catch (e) {
        $scope.data.table_cols = angular.copy($scope.data.table_cols_preset);
      }
    }

    function initController() {
      initMessageFilters();
    }

    function _doShow() {
      getMessages();
    }

    function getMessages() {
      block_messages_list.start();
      $scope.data.messagesList = null;

      $scope.data.summaryMessages = {};
      initTableColumns();

      var params = angular.copy($scope.params.messages);

      if ($routeParams.user_id) {
        params.user_id_value = $routeParams.user_id;
        params.user_id_type = 'id';
      }

      for (var i in params)
        if (params[i] === 'all')
          delete params[i];

      params.sort = '{0} {1}'.format(params.sort_field, params.sort_direction);
      delete params.sort_direction;
      delete params.sort_field;

      params.date_from = moment(params.date_from).set({
        hour: moment(params.time_from).get('hour'),
        minute: moment(params.time_from).get('minute'),
        second: moment(params.time_frome).get('second')
      });
      delete params.time_from;

      params.date_to = moment(params.date_to).set({
        hour: moment(params.time_to).get('hour'),
        minute: moment(params.time_to).get('minute'),
        second: moment(params.time_to).get('second')
      });
      delete params.time_to;

      if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id && $scope.data.currentLoyalty.id !== '0')
        params.loyalty = $scope.data.currentLoyalty.id;

      params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', true);
      params = cleanRequestData(params);

      MessageService.All(params, function(success, response) {
        if (success) {
          $rootScope.getBusinessStatus();

          $scope.data.messagesList = response.data;

          $scope.data.summaryMessages = response.summary;

          $rootScope.ENV.filters.messages_list.params = JSON.stringify($scope.params.messages);
          $rootScope.storeENV();
        }
        $timeout(function() {
          block_messages_list.stop();
        }, 1000);
      });
    }

    $scope.showEmailText = function(htmlText) {
      $scope.operationResult = $uibModal.open({
        animation: true,
        keyboard: true,
        templateUrl: 'app/templates/modal.show.htmlemail.html',
        size: 'md',
        controllerAs: 'popup',
        controller: function($uibModalInstance) {
          var popup = this;

          // fix modal width  and sanitize
          htmlText = htmlText.replace('width="700"', '').replace('min-width:650px', '');
          htmlText = $sce.trustAsHtml(htmlText);

          popup.model = {
            html: htmlText
          };

          //  TODO later
          // var modalWindowWidth = document.getElementsByClassName('embed-email-html')[0].offsetWidth;
          // var all_images_in_modal_window = document.querySelectorAll('.embed-email-html img');
          //
          // all_images_in_modal_window && all_images_in_modal_window.forEach(function (item) {
          //     item.css.maxWidth = modalWindowWidth;
          // });

          popup.onCancelClick = function() {
            $uibModalInstance.close();
          };
        }
      });
    };

    $scope.getTableHeaderClass = function(row) {
      return {
        'sorting_asc': $scope.params.messages.sort_field == row.value && $scope.params.messages.sort_direction == 'ASC',
        'sorting_desc': $scope.params.messages.sort_field == row.value && $scope.params.messages.sort_direction == 'DESC',
        'sorting': !row.not_sortable
      };
    };

    $scope.onSortOrderChange = function(row) {
      if (!!row.not_sortable) {
        return;
      }
      var field = row.value;
      if ($scope.params.messages.sort_field === field)
        $scope.params.messages.sort_direction = $scope.params.messages.sort_direction == 'ASC' ? 'DESC' : 'ASC';

      $scope.params.messages.sort_field = field;

      getMessages();
    };

    $scope.pageChange = function() {
      getMessages();
    };

    $scope.onCountChange = function(count) {
      $scope.params.messages.page = 1;
      $scope.params.messages.count = count;
      getMessages();
    };

    $scope.isCanBeReplied = function(msg) {
      return msg.type == 'incust-messenger' && msg.src_type == 'user' && msg.dst_type == 'business' && msg.title == 'CUSTOMER';
    };

    $scope.onReply = function(msg, to_helpdesk) {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: true,
        templateUrl: 'app/templates/modal.messages.sendmessage.html',
        controllerAs: 'popup',
        controller: function($scope, $uibModalInstance) {
          var popup = this;

          popup.msg = msg;
          popup.target = 'client';
          popup.onReplySend = function(message) {
            var post_data = {
              message: popup.message
            };

            if (to_helpdesk) {
              BusinessService.SendMessageToIncust(post_data, function(success, response) {
                if (success) {
                  // getMessages();
                  NotifyService.Success($filter('translate')('Message sent successfully'), false);
                }
              });
            } else {
              MessageService.Reply(msg.id, post_data, function(success, response) {
                if (success) {
                  // getMessages();
                  NotifyService.Success($filter('translate')('Message sent successfully'), false);
                }
              });
            }
            $uibModalInstance.close();
          };
          popup.onReplyCancel = function() {
            $uibModalInstance.dismiss('cancel');
          };
        }
      });
    };

    $scope.isReaded = function(msg) {
      return (msg.type == 'incust-messenger' && msg.src_type == 'user' && msg.dst_type == 'business' && msg.title == 'CUSTOMER' &&
              msg.readed == 0) ||
          (msg.type == 'incust-messenger' && msg.src_type == 'system' && msg.dst_type == 'business' && msg.title == 'SYSTEM REPLY' &&
              msg.readed == 0);
    };

    $scope.onMarkAsRead = function(msg) {
      MessageService.MarkAsRead(msg.id, function(success, response) {
        if (success) {
          var ml = $scope.data.messagesList;
          for (var i in ml) {
            if (ml[i].id === msg.id) {
              ml[i].readed = 1;
            }
          }
        }
      });
    };

    $scope.getMessageTypeDescription = function(message_type) {
      var res;
      switch (message_type) {
        case 'USER AUTOCREATED':
          res = 'TEXT_MESSAGE_TYPE_USER_ADDED';
          break;
        case 'TRANSACTION SUCCESS':
          res = 'TEXT_MESSAGE_TYPE_TRANSACTION';
          break;
        case 'CUSTOMER':
          res = 'TEXT_MESSAGE_TYPE_MESSAGE_FROM_CUSTOMER';
          break;
        case 'BUSINESS REPLY':
          res = 'TEXT_MESSAGE_TYPE_MESSAGE_TO_CUSTOMER';
          break;
        case 'BUSINESS':
          res = 'TEXT_MESSAGE_TYPE_MESSAGE_TO_PLATFORM';
          break;
        case 'SYSTEM REPLY':
          res = 'TEXT_MESSAGE_TYPE_MESSAGE_FROM_PLATFORM';
          break;
        case 'REMIND TERMINAL':
          res = 'TEXT_MESSAGE_TYPE_REMINDER';
          break;
        case 'NEWS':
          res = 'TEXT_MESSAGE_TYPE_NEWS_NOTIFICATION';
          break;
        case 'BUSINESS SUSPEND':
          res = 'TEXT_MESSAGE_TYPE_SUSPENDED';
          break;
        case 'BUSINESS MARKETING':
          res = 'TEXT_MESSAGE_TYPE_MARKETING';
          break;
        case 'BUSINESS CUSTOMER MESSAGES':
          res = 'TEXT_MESSAGE_TYPE_UNREAD_NOTIFICATION';
          break;
        case 'ADD BONUSES':
          res = 'TEXT_MESSAGE_TYPE_CREDIT_NOTIFICATION';
          break;
        case 'BONUS REDEEM':
          res = 'TEXT_MESSAGE_TYPE_PIN_CUSTOMER';
          break;
        case 'BONUSES EXPIRE':
          res = 'TEXT_MESSAGE_TYPE_EXPIRATION_NOTIFICATION';
          break;
        case 'COUPON EMISSION':
          res = 'TEXT_MESSAGE_TYPE_COUPON_EMITTED';
          break;
        case 'COUPON REDEEM':
          res = 'TEXT_MESSAGE_TYPE_COUPON_REDEEM';
          break;
        default:
          res = '';
      }
      return res;
    };

    $scope.isFromHelpdesk = function(msg) {
      return msg.type == 'incust-messenger' && msg.src_type == 'system' && msg.dst_type == 'business' && msg.title == 'SYSTEM REPLY';
    };

    $scope.onDisplaySettingsClick = function() {
      if ($scope.data.showTableDisplaySettings) {
        $rootScope.ENV.filters.messages_list.table_cols = JSON.stringify($scope.data.table_cols);
        $rootScope.storeENV();
      }

      $scope.data.showTableDisplaySettings = !$scope.data.showTableDisplaySettings;
    };

    $scope.onDisplaySettingsSave = function() {
      // $rootScope.ENV.filters.messages_list.table_cols = JSON.stringify($scope.data.table_cols);
      // $rootScope.storeENV();
      // NotifyService.Success("", false);
      $scope.onDisplaySettingsClick();
    };

    $scope.onColumnDisplayChange = function(index) {
      for (var i in $scope.data.table_cols[index].data)
        $scope.data.table_cols[index].data[i].visible = $scope.data.table_cols[index].visible;
    };

    $scope.onColumnDataDisplayChange = function(index) {
      $scope.data.table_cols.forEach(function(column) {
        return column.visible = column.data.some(function(data) {
          return data.visible;
        });
      });
    };

    $scope.onColumnAdd = function(first) {
      if (first)
        $scope.data.table_cols.unshift({visible: true, data: []});
      else
        $scope.data.table_cols.push({visible: true, data: []});
    };

    $scope.onColumnsReset = function() {
      initTableColumns();
    };

    $scope.onColumnRemove = function(index) {
      $scope.data.table_cols.splice(index, 1);
    };

    $rootScope.$watch('LOYALTIES', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);
        $scope.data.loyaltiesList.unshift({title: $filter('translate')('All loyalties'), id: '0', active: 1});

        if ($rootScope.ENV.filters.messages_list) {
          try {
            $scope.params.messages = JSON.parse($rootScope.ENV.filters.messages_list.params);
            $scope.params.messages.date_from = moment().subtract(3, 'month').utc().toDate();
            $scope.params.messages.date_to = moment().endOf('day').utc().toDate();
            $scope.params.messages.time_from = moment().startOf('day').utc().toDate();
            $scope.params.messages.time_to = moment().endOf('day').utc().toDate();

            $scope.params.messages.page = 1;
          } catch (e) {
            $scope.params.messages = angular.copy($scope.params.messages_preset);
          }
        }

        var saved_loyalty;

        if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
          $scope.data.currentLoyalty = $scope.data.loyaltiesList.find(function(filterItem) {
            if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
              return true;
            }
          });
        } else {
          var index;

          for (var i in $scope.data.loyaltiesList)
            if ($scope.data.loyaltiesList[i].id === '0')
              $scope.data.currentLoyalty = $scope.data.loyaltiesList[i];
        }
      }
    });

    $scope.$watch('data.currentLoyalty', function(newValue, oldValue) {
      if (newValue) {
        _doShow();

        $rootScope.ENV.filters.messages_list = {
          loyalty_id: newValue.id
        };
        $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
        $rootScope.storeENV();
      }
    }, true);

    $scope.$watchCollection(
        '[params.messages.message_type, params.messages.src_type, params.messages.status, params.messages.readed, params.messages.phone]',
        function(newCollection, oldCollection) {
          if (newCollection && newCollection !== oldCollection) {
            // if (filterTimeout)
            //     $timeout.cancel(filterTimeout);
            //
            // filterTimeout = $timeout(function () {
            //     $scope.params.messages.page = 1;
            //     console.log('filterTimeout::getMessages', newCollection, oldCollection)
            //     getMessages();
            // }, 1000);
          }
        });
  }
})();
